<!-- ============================================================================
     INTEGRAÇÃO GPL — Conferência (cega) de vendas do Sistema Legado (Aerosys)
     Ver comentário de topo em estoque-conferencia-itens-legado.component.ts
     ============================================================================ -->
<div class="es-shell">
  <div class="container">

    <!-- HEADER CARD -->
    <div class="header-card">
      <div class="hc-top">
        <button class="btn-voltar" (click)="onVoltar()">
          <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="19" y1="12" x2="5" y2="12"></line><polyline points="12 19 5 12 12 5"></polyline></svg>
          Voltar
        </button>
        <div class="hc-top-right">
          <span class="hc-badge">#{{ numVenda || idVenda }}</span>
          <span class="hc-tag-badge" title="Venda do Sistema Legado (Aerosys)">AERO</span>
          <span class="hc-quem-badge" *ngIf="identificado && nomeAtual" title="Identificado nesta venda: {{ nomeAtual }}">
            <span class="hc-quem-nome">{{ primeiroNome(nomeAtual) }}</span>
            <button type="button" class="hc-quem-trocar" (click)="trocarIdentificacao()">Trocar</button>
          </span>
        </div>
      </div>

      <!-- Ações -->
      <div class="hc-acoes" *ngIf="identificado && itens.length > 0">
        <button class="btn-finalizar-header" (click)="abrirModalFinalizar()" [disabled]="totalConferidos === 0" title="Finalizar a conferência agora, mesmo com itens ainda pendentes">
          <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"></polyline></svg>
          Finalizar Conferência
        </button>
      </div>
    </div>

    <!-- STATES -->
    <div *ngIf="identificado && carregando" class="loading-state">
      <app-loading-indicator></app-loading-indicator>
      <span>Carregando itens...</span>
    </div>

    <div *ngIf="identificado && erro" class="alert alert-danger">
      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"></circle><line x1="12" y1="8" x2="12" y2="12"></line><line x1="12" y1="16" x2="12.01" y2="16"></line></svg>
      {{ erro }}
    </div>

    <div *ngIf="identificado && erroSalvar" class="alert alert-danger" style="margin-bottom:12px">
      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"></circle><line x1="12" y1="8" x2="12" y2="12"></line><line x1="12" y1="16" x2="12.01" y2="16"></line></svg>
      {{ erroSalvar }}
    </div>

    <!-- LISTA DE ITENS -->
    <div class="content-card" *ngIf="identificado && !carregando && !erro && itens.length > 0">

      <div class="progress-bar-container">
        <div class="progress-info">
          <span>
            Itens conferidos ({{ totalConferidos }}/{{ itens.length }})
            <ng-container *ngIf="totalPendentesAbertas > 0"> · {{ totalPendentesAbertas }} no outro galpão</ng-container>
          </span>
          <span>{{ progresso }}%</span>
        </div>
        <div class="progress-bg">
          <div class="progress-fill" [style.width]="progresso + '%'"></div>
        </div>
      </div>

      <div class="abas-wrap">
        <button class="aba-btn" [class.ativa]="abaAtiva === 'pendentes'" (click)="abaAtiva = 'pendentes'">
          A Conferir
          <span class="aba-count" [class.count-alert]="itensPendentes.length > 0">{{ itensPendentes.length }}</span>
        </button>
        <button class="aba-btn" [class.ativa]="abaAtiva === 'conferidos'" (click)="abaAtiva = 'conferidos'">
          Já Conferidos
          <span class="aba-count" [class.count-ok]="itensConferidosLista.length > 0">{{ itensConferidosLista.length }}</span>
        </button>
      </div>

      <!-- Aba: A Conferir -->
      <div class="itens-list" *ngIf="abaAtiva === 'pendentes'">
        <div class="empty-aba" *ngIf="itensPendentes.length === 0">
          <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"></polyline></svg>
          Todos os itens foram conferidos!
        </div>
        <div class="sequencia-hint" *ngIf="itensPendentes.length > 0">
          Item {{ totalConferidos + 1 }} de {{ itens.length }}
        </div>
        <div class="item-card item-card-conferencia" *ngFor="let item of itemPendenteAtual">
          <span class="item-ordem">{{ totalConferidos + 1 }}</span>
          <div class="item-details">
            <div class="campo-row" *ngIf="item.pn">
              <span class="campo-valor"><span class="pn-label">P/N</span> {{ item.pn }}</span>
              <span class="badge qty">Pendente: {{ item.quantidade }}</span>
            </div>
            <div class="campo-row" *ngIf="!item.pn">
              <span class="campo-valor">{{ item.descricao }}</span>
              <span class="badge qty">Pendente: {{ item.quantidade }}</span>
            </div>
            <div class="item-descricao" *ngIf="item.pn">{{ item.descricao }}</div>
            <div class="campo-row" *ngIf="item.cd">
              <span class="campo-valor"><span class="pn-label">CD</span> {{ item.cd }}</span>
              <span class="badge loc" *ngIf="item.local">
                <svg xmlns="http://www.w3.org/2000/svg" width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"></path><circle cx="12" cy="10" r="3"></circle></svg>
                {{ item.local }}
              </span>
            </div>
            <div class="campo-row" *ngIf="item.apeId">
              <span class="campo-valor"><span class="pn-label">COD</span> {{ item.apeId }}</span>
              <span class="badge estoque" [class.negativo]="item.estoque !== undefined && item.estoque !== null && item.estoque <= 0" *ngIf="item.estoque !== undefined && item.estoque !== null" title="Saldo disponível">Disponível: {{ item.estoque }}</span>
            </div>
            <div class="serial-row" *ngIf="item.controlaSerial || item.formEscolhido">
              <span class="badge lote" *ngIf="item.formEscolhido">
                <svg xmlns="http://www.w3.org/2000/svg" width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"></path></svg>
                FORM: {{ item.formEscolhido }}
              </span>
              <ng-container *ngIf="item.controlaSerial">
                <span class="badge serial" *ngIf="item.serialEscolhido">
                  <svg xmlns="http://www.w3.org/2000/svg" width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="2" y="7" width="20" height="14" rx="2" ry="2"></rect><path d="M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16"></path></svg>
                  SERIAL: {{ item.serialEscolhido }}
                </span>
              </ng-container>
            </div>
            <div class="consumo-lotes" *ngIf="item.consumoLotes && item.consumoLotes.length > 1">
              <span class="consumo-lotes-titulo">Separado de {{ item.consumoLotes.length }} lotes:</span>
              <div class="consumo-lote-linha" *ngFor="let c of item.consumoLotes">
                <span class="consumo-lote-qtd">{{ c.quantidade }}x</span>
                <span class="consumo-lote-form" *ngIf="c.form">FORM: {{ c.form }}</span>
                <span class="consumo-lote-lote" *ngIf="c.lote">LOTE: {{ c.lote }}</span>
                <span class="consumo-lote-serial" *ngIf="c.serial">SERIAL: {{ c.serial }}</span>
              </div>
            </div>
            <div class="item-observacao" *ngIf="item.observacao">{{ item.observacao }}</div>

            <!-- Confirmação por QUANTIDADE (ver comentário de topo do .ts) -->
            <div class="confirmar-qtd-box">
              <label class="confirmar-qtd-label">Quantidade conferida</label>
              <div class="confirmar-qtd-row">
                <input
                  type="number"
                  class="confirmar-qtd-input"
                  [(ngModel)]="quantidadeDraft"
                  min="0"
                  [max]="item.quantidade ?? null"
                  step="1"
                  [disabled]="confirmando || carregandoPreview"
                />
                <button class="btn-confirmar-qtd" (click)="confirmarQuantidade()" [disabled]="confirmando || carregandoPreview"><app-loading-indicator *ngIf="(confirmando || carregandoPreview)" size="inline"></app-loading-indicator>
                  <svg *ngIf="!confirmando && !carregandoPreview" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"></polyline></svg>
                  {{ (confirmando || carregandoPreview) ? 'Aguarde...' : 'Confirmar' }}
                </button>
              </div>
              <p class="confirmar-qtd-hint" *ngIf="quantidadeDraft != null && item.quantidade != null && quantidadeDraft < item.quantidade">
                Quantidade menor que a pendente — a linha será desmembrada (vamos pedir confirmação antes de gravar).
              </p>
              <div *ngIf="erroConfirmar" class="alert alert-danger" style="margin-top:8px">{{ erroConfirmar }}</div>
            </div>

            <div class="item-acoes-row">
              <button class="btn-item-pendencia" (click)="abrirModalPendencia(item, $event)" title="Sinalizar que este item está no outro galpão">
                <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="1" y="3" width="15" height="13"></rect><polygon points="16 8 20 8 23 11 23 16 16 16 16 8"></polygon><circle cx="5.5" cy="18.5" r="2.5"></circle><circle cx="18.5" cy="18.5" r="2.5"></circle></svg>
                Item no outro Galpão
              </button>
            </div>
          </div>
        </div>
      </div>

      <!-- Aba: Já Conferidos -->
      <div class="itens-list" *ngIf="abaAtiva === 'conferidos'">
        <div class="empty-aba" *ngIf="itensConferidosLista.length === 0">
          Nenhum item conferido ainda.
        </div>
        <div class="item-card separado" [class.pendente-galpao]="item.pendente" *ngFor="let item of itensConferidosLista; let i = index">
          <span class="item-ordem item-ordem-separado">{{ i + 1 }}</span>
          <div class="checkbox-wrapper">
            <div class="custom-checkbox" *ngIf="!item.pendente">
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"></polyline></svg>
            </div>
            <div class="custom-checkbox custom-checkbox-pendente" *ngIf="item.pendente" title="Item no outro Galpão">
              <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="1" y="3" width="15" height="13"></rect><polygon points="16 8 20 8 23 11 23 16 16 16 16 8"></polygon><circle cx="5.5" cy="18.5" r="2.5"></circle><circle cx="18.5" cy="18.5" r="2.5"></circle></svg>
            </div>
          </div>
          <div class="item-details">
            <div class="campo-row" *ngIf="item.pn">
              <span class="campo-valor"><span class="pn-label">P/N</span> {{ item.pn }}</span>
              <span class="badge qty">Qtde: {{ item.quantidade }}</span>
            </div>
            <div class="campo-row" *ngIf="!item.pn">
              <span class="campo-valor">{{ item.descricao }}</span>
              <span class="badge qty">Qtde: {{ item.quantidade }}</span>
            </div>
            <div class="item-descricao" *ngIf="item.pn">{{ item.descricao }}</div>
            <div class="campo-row" *ngIf="item.cd">
              <span class="campo-valor"><span class="pn-label">CD</span> {{ item.cd }}</span>
              <span class="badge loc" *ngIf="item.local">
                <svg xmlns="http://www.w3.org/2000/svg" width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"></path><circle cx="12" cy="10" r="3"></circle></svg>
                {{ item.local }}
              </span>
            </div>
            <div class="serial-row" *ngIf="item.controlaSerial || item.formEscolhido">
              <span class="badge lote" *ngIf="item.formEscolhido">
                <svg xmlns="http://www.w3.org/2000/svg" width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"></path></svg>
                FORM: {{ item.formEscolhido }}
              </span>
              <ng-container *ngIf="item.controlaSerial">
                <span class="badge serial" *ngIf="item.serialEscolhido">
                  <svg xmlns="http://www.w3.org/2000/svg" width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="2" y="7" width="20" height="14" rx="2" ry="2"></rect><path d="M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16"></path></svg>
                  SERIAL: {{ item.serialEscolhido }}
                </span>
              </ng-container>
            </div>
            <div class="consumo-lotes" *ngIf="item.consumoLotes && item.consumoLotes.length > 1">
              <span class="consumo-lotes-titulo">Separado de {{ item.consumoLotes.length }} lotes:</span>
              <div class="consumo-lote-linha" *ngFor="let c of item.consumoLotes">
                <span class="consumo-lote-qtd">{{ c.quantidade }}x</span>
                <span class="consumo-lote-form" *ngIf="c.form">FORM: {{ c.form }}</span>
                <span class="consumo-lote-lote" *ngIf="c.lote">LOTE: {{ c.lote }}</span>
                <span class="consumo-lote-serial" *ngIf="c.serial">SERIAL: {{ c.serial }}</span>
              </div>
            </div>
            <div class="item-meta" *ngIf="item.conferenteNome && !item.pendente">
              <span class="badge unit">Conferido por: {{ item.conferenteNome }}</span>
            </div>
            <div class="pendencia-galpao-box" *ngIf="item.pendente">
              <span class="badge pendencia-galpao-badge">
                <svg xmlns="http://www.w3.org/2000/svg" width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="1" y="3" width="15" height="13"></rect><polygon points="16 8 20 8 23 11 23 16 16 16 16 8"></polygon><circle cx="5.5" cy="18.5" r="2.5"></circle><circle cx="18.5" cy="18.5" r="2.5"></circle></svg>
                Item no outro Galpão
              </span>
              <span class="pendencia-galpao-obs" *ngIf="item.pendenteObservacao">{{ item.pendenteObservacao }}</span>
            </div>
            <div class="item-observacao" *ngIf="item.observacao">{{ item.observacao }}</div>
            <div class="item-acoes-row" *ngIf="item.pendente">
              <button class="btn-item-desfazer-pendencia" (click)="desfazerPendencia(item, $event)" [disabled]="desfazendoPendenciaIvdId === item.ivdId">
                <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="1 4 1 10 7 10"></polyline><path d="M3.51 15a9 9 0 1 0 2.13-9.36L1 10"></path></svg>
                {{ desfazendoPendenciaIvdId === item.ivdId ? 'Desfazendo...' : 'Desfazer sinalização' }}
              </button>
            </div>
          </div>
        </div>
      </div>

      <div class="action-footer">
        <ng-container *ngIf="allDone">
          <div class="banner-todos-separados">
            <div class="banner-icone">
              <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path><polyline points="22 4 12 14.01 9 11.01"></polyline></svg>
            </div>
            <div class="banner-texto">
              <strong>Todos os itens foram conferidos!</strong>
              <span>Deseja finalizar a conferência desta venda?</span>
            </div>
          </div>
          <button class="btn-concluir" (click)="finalizar()" [disabled]="finalizando">
            <svg *ngIf="!finalizando" xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"></polyline></svg>
            {{ finalizando ? 'Finalizando...' : 'Finalizar Conferência' }}
          </button>
        </ng-container>

        <div *ngIf="erroFinalizar" class="alert alert-danger" style="margin-top:12px">
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"></circle><line x1="12" y1="8" x2="12" y2="12"></line><line x1="12" y1="16" x2="12.01" y2="16"></line></svg>
          {{ erroFinalizar }}
        </div>
      </div>

    </div>
  </div>
</div>

<!-- ── RESTAURANDO IDENTIFICAÇÃO LEMBRADA (silencioso, sem modal) ────────── -->
<div class="modal-overlay" *ngIf="!identificado && restaurandoIdentificacao">
  <div class="modal-box" style="text-align:center; padding:36px 32px">
    <app-loading-indicator style="margin:0 auto 14px"></app-loading-indicator>
    <span style="color:var(--text-muted)">Retomando identificação anterior...</span>
  </div>
</div>

<!-- ── MODAL IDENTIFICAÇÃO "QUEM SOU VOCÊ" (só usuário, sem TAG) ─────────── -->
<div class="modal-overlay" *ngIf="!identificado && !restaurandoIdentificacao">
  <div class="modal-box" (click)="$event.stopPropagation()">
    <div class="modal-header">
      <h2>
        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="vertical-align:-3px;margin-right:6px"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path><circle cx="12" cy="7" r="4"></circle></svg>
        Quem está conferindo?
      </h2>
    </div>
    <div class="modal-body">
      <p class="modal-desc">O Aerosys não sabe quem está usando esta tela — selecione o seu usuário antes de continuar.</p>

      <label class="id-label">Usuário</label>
      <div class="busca-usuario-wrap">
        <input
          type="text"
          class="id-input"
          [(ngModel)]="buscaUsuario"
          (ngModelChange)="onBuscaUsuarioChange()"
          placeholder="Digite seu nome"
          [disabled]="!!usuarioEscolhido"
        />
        <button class="btn-limpar-usuario" *ngIf="usuarioEscolhido" (click)="limparUsuarioEscolhido()">Trocar</button>
      </div>
      <div class="loading-seriais" *ngIf="buscandoUsuarios">
        <app-loading-indicator size="inline"></app-loading-indicator> Buscando usuários...
      </div>
      <div class="seriais-lista" *ngIf="!usuarioEscolhido && usuariosSugeridos.length > 0">
        <div class="serial-opcao" *ngFor="let u of usuariosSugeridos" (click)="escolherUsuario(u)">
          <div class="serial-opcao-info">
            <span class="serial-opcao-num">{{ u.nome }}</span>
          </div>
        </div>
      </div>
      <div class="empty-seriais" *ngIf="!usuarioEscolhido && !buscandoUsuarios && !erroIdentificacao && usuariosSugeridos.length === 0 && buscaUsuario.trim().length >= 2">
        Nenhum usuário encontrado para "{{ buscaUsuario }}".
      </div>

      <div *ngIf="erroIdentificacao" class="alert alert-danger" style="margin-top:12px">{{ erroIdentificacao }}</div>
    </div>
    <div class="modal-footer">
      <button class="btn-concluir" (click)="confirmarIdentificacao()" [disabled]="!usuarioEscolhido || identificando">
        <span *ngIf="!identificando">Continuar</span>
        <span *ngIf="identificando"><app-loading-indicator size="inline"></app-loading-indicator> Aguarde...</span>
      </button>
    </div>
  </div>
</div>

<!-- ── MODAL CONFIRMAR DESMEMBRAMENTO (prévia antes/depois) ──────────────── -->
<div class="modal-overlay" *ngIf="modalDesmembramento" (click)="fecharModalDesmembramento()">
  <div class="modal-box" (click)="$event.stopPropagation()">
    <div class="modal-header">
      <h2>Confirmar Desmembramento</h2>
      <button class="btn-fechar-modal" (click)="fecharModalDesmembramento()" [disabled]="confirmando">
        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>
      </button>
    </div>
    <div class="modal-body" *ngIf="previewResultado as pv">
      <p class="modal-desc">
        A quantidade conferida é menor que a pendente — este item vai ser dividido em dois:
        a parte <strong>atendida agora</strong> e a <strong>sobra</strong>, que continua pendente para uma futura conferência.
      </p>

      <div class="desmembramento-comparativo">
        <div class="desmembramento-card desmembramento-card-sobra">
          <span class="desmembramento-card-titulo">Item atual (sobra)</span>
          <span class="desmembramento-card-pn">{{ pv.pn }}</span>
          <span class="desmembramento-card-desc">{{ pv.descricao }}</span>
          <span class="desmembramento-card-qtd">Quantidade: <strong>{{ pv.quantidadeRestante }}</strong></span>
          <span class="desmembramento-card-valor" *ngIf="pv.subTotalAtual != null">Subtotal: {{ pv.subTotalAtual | number:'1.2-2' }}</span>
        </div>
        <div class="desmembramento-seta">
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="5" y1="12" x2="19" y2="12"></line><polyline points="12 5 19 12 12 19"></polyline></svg>
        </div>
        <div class="desmembramento-card desmembramento-card-novo">
          <span class="desmembramento-card-titulo">Novo item (atendido agora)</span>
          <span class="desmembramento-card-pn">{{ pv.pn }}</span>
          <span class="desmembramento-card-desc">{{ pv.descricao }}</span>
          <span class="desmembramento-card-qtd">Quantidade: <strong>{{ pv.quantidadeConferida }}</strong></span>
          <span class="desmembramento-card-valor" *ngIf="pv.subTotalNovo != null">Subtotal: {{ pv.subTotalNovo | number:'1.2-2' }}</span>
        </div>
      </div>

      <div *ngIf="erroPreview" class="alert alert-danger" style="margin-top:12px">{{ erroPreview }}</div>
    </div>
    <div class="modal-footer">
      <button class="btn-cancelar-modal" (click)="fecharModalDesmembramento()" [disabled]="confirmando">Cancelar</button>
      <button class="btn-concluir" (click)="confirmarDesmembramento()" [disabled]="confirmando">
        {{ confirmando ? 'Confirmando...' : 'Confirmar Desmembramento' }}
      </button>
    </div>
  </div>
</div>

<!-- ── MODAL FINALIZAR CONFERÊNCIA ───────────────────────────────────────── -->
<div class="modal-overlay" *ngIf="modalFinalizar" (click)="modalFinalizar = false">
  <div class="modal-box modal-finalizar" (click)="$event.stopPropagation()">
    <div class="modal-finalizar-body">
      <div class="modal-finalizar-icone">
        <svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path><polyline points="22 4 12 14.01 9 11.01"></polyline></svg>
      </div>
      <h2 *ngIf="allDone">Todos os itens foram conferidos!</h2>
      <h2 *ngIf="!allDone">Finalizar com itens pendentes?</h2>
      <p *ngIf="allDone">Deseja finalizar a conferência desta venda?</p>
      <p *ngIf="!allDone">
        {{ itensPendentes.length + totalPendentesAbertas }} item(ns) ainda não {{ (itensPendentes.length + totalPendentesAbertas) === 1 ? 'foi conferido' : 'foram conferidos' }}.
        Ao finalizar agora, a venda fica com status <strong>ESTOQUE</strong> (aguardando os itens restantes numa conferência futura).
      </p>
      <div class="modal-finalizar-acoes">
        <button class="btn-cancelar-modal" (click)="modalFinalizar = false">Agora não</button>
        <button class="btn-concluir btn-concluir-modal" (click)="finalizarDoModal()" [disabled]="finalizando">
          <svg *ngIf="!finalizando" xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"></polyline></svg>
          {{ finalizando ? 'Finalizando...' : 'Finalizar Conferência' }}
        </button>
      </div>
      <div *ngIf="erroFinalizar" class="alert alert-danger" style="margin-top:12px">{{ erroFinalizar }}</div>
    </div>
  </div>
</div>

<!-- ── MODAL "ITEM NO OUTRO GALPÃO" ──────────────────────────────────────── -->
<div class="modal-overlay" *ngIf="modalPendencia" (click)="fecharModalPendencia()">
  <div class="modal-box" (click)="$event.stopPropagation()">
    <div class="modal-header">
      <h2>Item no outro Galpão</h2>
      <button class="btn-fechar-modal" (click)="fecharModalPendencia()" [disabled]="marcandoPendente">
        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>
      </button>
    </div>
    <div class="modal-body">
      <p class="modal-desc" *ngIf="itemPendencia">
        <strong>{{ itemPendencia.pn || itemPendencia.descricao }}</strong> -- este item não está aqui, está no
        galpão vizinho. Ele sai da fila "A Conferir" (você segue pro próximo) e fica visível na tela global
        "Itens Pendentes" até alguém buscar e confirmar. Você ainda pode <strong>Finalizar</strong> a conferência
        desta venda com o item sinalizado assim.
      </p>
      <textarea
        class="observacao-textarea"
        [(ngModel)]="pendenciaObservacaoRascunho"
        placeholder="Nota opcional (ex.: 'está no galpão 2, prateleira B')"
        rows="4"
        maxlength="2000"
        [disabled]="marcandoPendente"
      ></textarea>
      <div *ngIf="erroPendencia" class="alert alert-danger" style="margin-top:12px">{{ erroPendencia }}</div>
    </div>
    <div class="modal-footer">
      <button class="btn-cancelar-modal" (click)="fecharModalPendencia()" [disabled]="marcandoPendente">Cancelar</button>
      <button class="btn-concluir" (click)="confirmarPendencia()" [disabled]="marcandoPendente">
        {{ marcandoPendente ? 'Sinalizando...' : 'Sinalizar Pendência' }}
      </button>
    </div>
  </div>
</div>
